import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "dropdown"]
  static values = { controls: String }

  connect() {
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this)
    document.addEventListener("click", this.closeOnOutsideClick)
    this.updateLabel()
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick)
  }

  toggle(event) {
    event.stopPropagation()
    const isOpen = this.dropdownTarget.style.display !== "none"
    // Close all other multiselect dropdowns first
    document.querySelectorAll(".mf-multiselect-dropdown").forEach(d => {
      if (d !== this.dropdownTarget) d.style.display = "none"
    })
    this.dropdownTarget.style.display = isOpen ? "none" : ""
  }

  update() {
    this.updateLabel()
    this.updateControlledField()
  }

  updateLabel() {
    const checkboxes = this.dropdownTarget.querySelectorAll("input[type='checkbox']")
    const checked = Array.from(checkboxes).filter(cb => cb.checked)
    const toggle = this.toggleTarget

    if (checked.length === 0) {
      toggle.textContent = this.defaultLabel()
      toggle.classList.remove("has-selections")
    } else {
      const labels = checked.map(cb => cb.closest("label").querySelector("span").textContent)
      toggle.textContent = labels.join(", ")
      toggle.classList.add("has-selections")
    }
  }

  defaultLabel() {
    const name = this.dropdownTarget.querySelector("input[type='checkbox']")?.name || ""
    if (name.includes("price_movement")) return "Any Prices"
    if (name.includes("distress")) return "Any Distress"
    if (name.includes("investor")) return "Any Activity"
    if (name.includes("cashflow")) return "Any Cashflow"
    if (name.includes("gross_rent")) return "Any Yield"
    return "Any"
  }

  updateControlledField() {
    if (!this.controlsValue) return
    const target = document.querySelector("." + this.controlsValue)
    if (!target) return
    const checkboxes = this.dropdownTarget.querySelectorAll("input[type='checkbox']")
    const anyChecked = Array.from(checkboxes).some(cb => cb.checked)
    target.style.display = anyChecked ? "" : "none"
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.style.display = "none"
    }
  }
}
